export const EMOJI_CATEGORIES = [
  {
    key: "frequent",
    label: "Frequently used",
    items: [
      { emoji: "👍", keywords: ["ok", "yes", "good", "approve", "thanks"] },
      { emoji: "✅", keywords: ["done", "complete", "confirmed"] },
      { emoji: "😊", keywords: ["smile", "nice", "happy"] },
      { emoji: "🙏", keywords: ["thanks", "thank you", "appreciate"] },
      { emoji: "❤️", keywords: ["love", "heart"] },
      { emoji: "🎉", keywords: ["yay", "celebrate", "congrats"] },
      { emoji: "👋", keywords: ["hi", "hello", "welcome", "bye"] },
      { emoji: "😂", keywords: ["lol", "funny", "laugh"] }
    ]
  },
  {
    key: "guest",
    label: "Guest & Stay",
    items: [
      { emoji: "🏡", keywords: ["home", "house", "property"] },
      { emoji: "🔑", keywords: ["key", "door", "code", "lock"] },
      { emoji: "🧳", keywords: ["check in", "checkin", "check out", "checkout", "travel", "luggage"] },
      { emoji: "🛏️", keywords: ["bed", "sleep"] },
      { emoji: "🚪", keywords: ["door", "entry"] },
      { emoji: "🚿", keywords: ["shower", "bathroom"] },
      { emoji: "🧼", keywords: ["clean", "cleaning", "soap"] },
      { emoji: "🧽", keywords: ["clean", "wipe"] },
      { emoji: "🧺", keywords: ["laundry", "towels"] },
      { emoji: "🛠️", keywords: ["maintenance", "fix", "repair"] },
      { emoji: "🔧", keywords: ["maintenance", "fix", "repair"] },
      { emoji: "⚠️", keywords: ["important", "warning", "attention"] },
      { emoji: "⏰", keywords: ["time", "late", "schedule"] },
      { emoji: "📍", keywords: ["location", "address", "directions", "pin"] }
    ]
  },
  {
    key: "nature",
    label: "Nature",
    items: [
      { emoji: "🌞", keywords: ["sun", "sunny"] },
      { emoji: "🌧️", keywords: ["rain", "rainy"] },
      { emoji: "❄️", keywords: ["snow", "cold"] },
      { emoji: "🌊", keywords: ["ocean", "wave", "beach"] },
      { emoji: "🌈", keywords: ["rainbow"] },
      { emoji: "🌲", keywords: ["tree", "forest"] },
      { emoji: "🌴", keywords: ["palm", "tropical"] },
      { emoji: "🌸", keywords: ["flower", "spring"] },
      { emoji: "🌺", keywords: ["flower"] },
      { emoji: "🌻", keywords: ["sunflower"] }
    ]
  },
  {
    key: "food",
    label: "Food & Drink",
    items: [
      { emoji: "☕", keywords: ["coffee"] },
      { emoji: "🍵", keywords: ["tea"] },
      { emoji: "🍕", keywords: ["pizza"] },
      { emoji: "🍔", keywords: ["burger"] },
      { emoji: "🥗", keywords: ["salad"] },
      { emoji: "🍪", keywords: ["cookie"] },
      { emoji: "🍰", keywords: ["cake", "dessert"] },
      { emoji: "🍷", keywords: ["wine"] },
      { emoji: "🥂", keywords: ["cheers", "toast", "celebrate"] }
    ]
  },
  {
    key: "travel",
    label: "Travel",
    items: [
      { emoji: "🚗", keywords: ["car", "drive"] },
      { emoji: "🛻", keywords: ["truck"] },
      { emoji: "🚕", keywords: ["taxi", "uber"] },
      { emoji: "✈️", keywords: ["flight", "plane", "airport"] },
      { emoji: "🗺️", keywords: ["map"] },
      { emoji: "📌", keywords: ["pin", "location"] },
      { emoji: "🧭", keywords: ["compass", "direction"] }
    ]
  },
{
  key: "smileys",
  label: "Smileys",
  items: [
    { emoji: "😀", keywords: ["happy", "smile", "grin"] },
    { emoji: "😄", keywords: ["happy", "smile", "grin"] },
    { emoji: "😊", keywords: ["smile", "friendly"] },
    { emoji: "🙂", keywords: ["smile", "okay"] },
    { emoji: "😉", keywords: ["wink"] },
    { emoji: "😍", keywords: ["love", "heart eyes"] },
    { emoji: "🥰", keywords: ["love", "cute"] },
    { emoji: "🤩", keywords: ["excited", "star"] },

    { emoji: "😂", keywords: ["lol", "laugh"] },
    { emoji: "🤣", keywords: ["rofl", "laugh"] },
    { emoji: "😅", keywords: ["sweat", "oops", "awkward"] },
    { emoji: "🤭", keywords: ["oops", "giggle"] },

    { emoji: "😮", keywords: ["wow", "surprised"] },
    { emoji: "😲", keywords: ["shocked", "surprise"] },
    { emoji: "😳", keywords: ["embarrassed", "oops"] },

    { emoji: "😌", keywords: ["relieved", "calm"] },
    { emoji: "🥹", keywords: ["touched", "thankful"] },

    { emoji: "😕", keywords: ["confused", "unsure"] },
    { emoji: "🙁", keywords: ["sad", "unhappy"] },
    { emoji: "😢", keywords: ["sad", "tear"] },
    { emoji: "😭", keywords: ["cry", "very sad"] },

    { emoji: "😤", keywords: ["frustrated", "annoyed"] },
    { emoji: "😡", keywords: ["angry", "mad"] }
  ]
},
  {
    key: "hearts",
    label: "Hearts",
    items: [
      { emoji: "❤️", keywords: ["heart", "love"] },
      { emoji: "💛", keywords: ["heart", "love"] },
      { emoji: "💚", keywords: ["heart", "love"] },
      { emoji: "💙", keywords: ["heart", "love"] },
      { emoji: "💜", keywords: ["heart", "love"] },
      { emoji: "🖤", keywords: ["heart", "love"] },
      { emoji: "🤍", keywords: ["heart", "love"] },
      { emoji: "💔", keywords: ["heart", "sad"] },
      { emoji: "❣️", keywords: ["heart", "love"] },
      { emoji: "💖", keywords: ["heart", "love"] }
    ]
  }
];